import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getAsset } from '../../../../util/assets';

const propTypes = {
  title: PropTypes.string,
  leftSlot: PropTypes.node,
  titleSlot: PropTypes.node,
  rightSlot: PropTypes.node,
  className: PropTypes.string,
};

const HeaderLayout = ({
  title = '',
  leftSlot,
  titleSlot,
  rightSlot,
  className,
}) => {
  const classes = classNames({
    'header-matches': true,
    [className]: !!className,
  });

  return (
    <header className={classes}>
      <div className="header-slot-left">
        {leftSlot || (
          <img
            src={getAsset('/waldo-icon.svg')}
            alt=""
            className="header-logo"
          />
        )}
      </div>

      <div className="header-slot-title">
        {titleSlot || (
          <span className="header-slot-title-content">{title}</span>
        )}
      </div>

      <div className="header-slot-right">{rightSlot}</div>
    </header>
  );
};

HeaderLayout.propTypes = propTypes;

export default HeaderLayout;
